(function () {
  if (window.__gwpSelectorInitialized) return;
  window.__gwpSelectorInitialized = true;

  const GWP_PROPERTY = '_gwp';
  const GWP_VALUE = 'true';
  let isAutoRemoving = false;
  let isUpdatingGwp = false;

  function getGwpSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  function dispatchCartUpdate(sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          sourceId: 'gwp-selector',
          data: { source: 'gwp-selector', sections: sections || {} },
        },
      })
    );
  }

  async function addGwpToCart(variantId) {
    const sectionIds = getGwpSectionIds();
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { [GWP_PROPERTY]: GWP_VALUE } }],
        sections: sectionIds.join(','),
      }),
    });
    if (!response.ok) throw new Error('GWP add failed');
    const data = await response.json();
    dispatchCartUpdate(data.sections || {});
  }

  async function removeGwpFromCart(key, skipSectionRender = false) {
    if (!key) return;
    const sectionIds = getGwpSectionIds();
    const body = { id: key, quantity: 0 };
    if (!skipSectionRender) {
      body.sections = sectionIds.join(',');
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error('GWP remove failed');
    const data = await response.json();
    if (!skipSectionRender) {
      dispatchCartUpdate(data.sections || {});
    }
  }

  function setOptionsLoading(state) {
    document.querySelectorAll('[data-gwp-option]').forEach((btn) => {
      btn.disabled = state;
    });
  }

  function isCartBusy() {
    const cartItemsDisabled = !!document.querySelector('cart-items-component.cart-items-disabled');
    const giftWrapState = window.__giftWrapDrawerState;
    const normalizing = !!(giftWrapState && giftWrapState.isNormalizingGiftWrapLines);
    const fastAddingGW = !!(giftWrapState && giftWrapState.isFastAddingGiftWrap);
    const fastAddingReg = !!(giftWrapState && giftWrapState.isFastAddingRegularProduct);
    
    const busy = isAutoRemoving || isUpdatingGwp || cartItemsDisabled || normalizing || fastAddingGW || fastAddingReg;
    if (busy) {
      console.log('[GWP Debug] isCartBusy is true because:', {
        isAutoRemoving,
        isUpdatingGwp,
        cartItemsDisabled,
        normalizing,
        fastAddingGW,
        fastAddingReg
      });
    }
    return busy;
  }

  async function handleOptionClick(button) {
    console.log('[GWP Debug] handleOptionClick called for variant:', button.dataset.variantId);
    
    if (isUpdatingGwp || isAutoRemoving) {
      console.log('[GWP Debug] Blocked: GWP update/remove in progress', { isUpdatingGwp, isAutoRemoving });
      return;
    }

    const cartItems = document.querySelector('cart-items-component');
    if (cartItems && cartItems.classList.contains('cart-items-disabled')) {
      console.log('[GWP Debug] Blocked: cart-items-component has cart-items-disabled class');
      return;
    }

    if (window.__giftWrapDrawerState && (
      window.__giftWrapDrawerState.isNormalizingGiftWrapLines ||
      window.__giftWrapDrawerState.isFastAddingGiftWrap ||
      window.__giftWrapDrawerState.isFastAddingRegularProduct
    )) {
      console.log('[GWP Debug] Blocked: gift wrap handler is busy', window.__giftWrapDrawerState);
      return;
    }

    const state = document.querySelector('.gwp-selector__state');
    const currentVariant = state ? state.dataset.gwpSelectedVariant : '';
    const currentKey = state ? state.dataset.gwpSelectedKey : '';
    const newVariant = button.dataset.variantId;
    console.log('[GWP Debug] GWP State details:', { currentVariant, currentKey, newVariant });
    if (currentVariant === newVariant) return;

    isUpdatingGwp = true;
    setOptionsLoading(true);

    // Optimistic UI Update: Immediately hide/remove the GWP product line item from the cart drawer DOM
    const existingGwpRow = document.querySelector('[data-gwp-item="true"]');
    if (existingGwpRow) {
      existingGwpRow.remove();
    }

    try {
      if (currentKey) {
        console.log('[GWP Debug] Removing current variant by key:', currentKey);
        await removeGwpFromCart(currentKey, true);
      }
      console.log('[GWP Debug] Adding new variant:', newVariant);
      await addGwpToCart(newVariant);
    } catch (e) {
      console.error('[GWP]', e);
    } finally {
      setOptionsLoading(false);
      isUpdatingGwp = false;
      console.log('[GWP Debug] handleOptionClick finished.');
    }
  }

  async function checkAutoRemove() {
    if (isAutoRemoving || isUpdatingGwp) return;
    const state = document.querySelector('.gwp-selector__state');
    if (!state) return;
    const qualifies = state.dataset.gwpQualifies === 'true';
    const selectedVariant = state.dataset.gwpSelectedVariant;
    const selectedKey = state.dataset.gwpSelectedKey;

    if (!qualifies) {
      // Immediately hide the GWP product selection list (options panel) if visible in DOM
      const optionsContainer = document.querySelector('.gwp-selector__options');
      if (optionsContainer) {
        optionsContainer.style.display = 'none';
      }

      if (selectedVariant) {
        // Immediately hide GWP item from cart drawer DOM
        const existingGwpRow = document.querySelector('[data-gwp-item="true"]');
        if (existingGwpRow) {
          existingGwpRow.remove();
        }

        isAutoRemoving = true;
        try {
          await removeGwpFromCart(selectedKey);
        } catch (e) {
          console.error('[GWP auto-remove]', e);
        } finally {
          isAutoRemoving = false;
        }
      }
    }
  }

  // Intercept checkout clicks to prevent checkout leak
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('button[name="checkout"], #checkout');
    if (!checkoutBtn) return;

    if (isCartBusy()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const state = document.querySelector('.gwp-selector__state');
    if (state) {
      const qualifies = state.dataset.gwpQualifies === 'true';
      const selectedVariant = state.dataset.gwpSelectedVariant;
      if (!qualifies && selectedVariant) {
        e.preventDefault();
        e.stopPropagation();
        checkAutoRemove();
      }
    }
  }, true);

  // Intercept checkout form submission
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.id !== 'cart-form' && !form.querySelector('button[name="checkout"]')) return;

    if (isCartBusy()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const state = document.querySelector('.gwp-selector__state');
    if (state) {
      const qualifies = state.dataset.gwpQualifies === 'true';
      const selectedVariant = state.dataset.gwpSelectedVariant;
      if (!qualifies && selectedVariant) {
        e.preventDefault();
        e.stopPropagation();
        checkAutoRemove();
      }
    }
  }, true);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-gwp-option]');
    if (!btn) return;
    await handleOptionClick(btn);
  });

  document.addEventListener('cart:update', () => {
    setTimeout(checkAutoRemove, 100);
  });

  checkAutoRemove();
})();
